import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { BACKEND_URL } from '../../utils/apiConfig';
import { authFetch } from '../../utils/authHelpers';

/**
 * Dupliceer een callsheet: alles wordt gekopieerd (crew/cast/programma/locaties),
 * alleen de datum kies je nieuw — daarna gewoon bewerken. Navigeert na afloop
 * naar de nieuwe callsheet. Gedeeld door lijst, editor en project-paneel.
 */
function DuplicateCallsheetDialog({ callsheet, onClose }) {
  const navigate = useNavigate();
  const [datum, setDatum] = useState('');
  const [busy, setBusy] = useState(false);

  const doDuplicate = async () => {
    if (!callsheet || busy) return;
    setBusy(true);
    try {
      const r = await authFetch(`${BACKEND_URL}/Api/callsheets/${callsheet.id}/duplicate`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ datum: datum || null }),
      });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).error || `HTTP ${r.status}`);
      const d = await r.json();
      toast.success('Callsheet gedupliceerd — je kunt nu aanpassen');
      onClose();
      navigate(`/callsheets/${d.id}`);
    } catch (e) {
      toast.error(`Dupliceren mislukt: ${e.message}`);
    } finally {
      setBusy(false);
      setDatum('');
    }
  };

  return (
    <Dialog open={!!callsheet} onClose={() => !busy && onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>Callsheet dupliceren</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          "{callsheet?.fields?.Titel || 'Callsheet'}" wordt volledig gekopieerd —
          crew, cast, programma en locaties. Kies alleen de nieuwe datum.
        </Typography>
        <TextField
          type="date" fullWidth size="small" label="Datum" InputLabelProps={{ shrink: true }}
          value={datum} onChange={(e) => setDatum(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Annuleren</Button>
        <Button variant="contained" onClick={doDuplicate} disabled={!datum || busy}>
          {busy ? 'Kopiëren…' : 'Dupliceren'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DuplicateCallsheetDialog;
